export default "__VITE_ASSET__4c531d1a__"